import './AuthCallback.scss';
import * as AuthActions from 'store/auth/auth.action';

import React, { useEffect, useMemo, useState } from 'react';

import LoadingIcon from 'components/Shared/LoadingIcon/LoadingIcon';
import Storage from 'services/storage';
import useActions from 'hooks/useActions';
import { useHistory, useParams } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import { FlightButton } from '@flybits/design-system';

export default function RedirectIndex() {
  const authActions = useActions(AuthActions);
  const history = useHistory();
  const { pid: projectID } = useParams<{ pid: string }>();
  const { getAuthToken, requestAuth } = useAuth(projectID);
  const storage = useMemo(() => new Storage(), []);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const origin = params.get('origin');
    const originHost = origin?.split('/#')[0];
    const path = params.get('path') ?? '';
    if (originHost) {
      storage.setItem(`${projectID}+origin`, originHost);
    }
    const getToken = async () => {
      try {
        const token = await getAuthToken();
        if (token) {
          await authActions.authenticateUser(token, projectID);
          const projectRoot = `/project/${projectID}`;
          const requestedURL = path ? new URL(path, window.location.origin) : null;
          const isCurrentProjectPath =
            requestedURL?.origin === window.location.origin &&
            (requestedURL.pathname === projectRoot || requestedURL.pathname.startsWith(`${projectRoot}/`));

          history.replace(
            isCurrentProjectPath ? `${requestedURL.pathname}${requestedURL.search}${requestedURL.hash}` : projectRoot,
          );
        } else {
          setErrorMessage('Something went wrong. Please try again.');
        }
      } catch (error) {
        setErrorMessage('Something went wrong. Please try again.');
        console.error(error);
      }
    };
    getToken();
  }, [authActions, history, projectID, getAuthToken, storage]);

  return (
    <div className="auth-callback-container">
      <div className="content">
        {errorMessage ? (
          <>
            <div className="error-message">{errorMessage}</div>
            <FlightButton theme="link" label="Retry" onClick={() => requestAuth()} />
          </>
        ) : (
          <>
            <LoadingIcon />
            <div>Please wait a few seconds while we authenticate you...</div>
          </>
        )}
      </div>
    </div>
  );
}
